import { render, staticRenderFns } from "./BedBuilder.vue?vue&type=template&id=e5db58fa"
import script from "./BedBuilder.vue?vue&type=script&lang=js"
export * from "./BedBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports